import React from 'react'
import Button from '../../components/buttons/buttons.component'
import styled from 'styled-components'
import Gallery from './components/gallery.component'
import Container from './../../components/layout/container.component'
import PaymentInfo from './components/payment-info.component'
import AccordionSecondary from '../../components/accordion/accordion-secondary.component'
import { StyledStoreProductContainer } from './components/styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { clientActions } from '../../actions/client.actions'
import { bindActionCreators } from 'redux'
import { StoreProductService } from './../../services/store-product.service'
import * as config from 'config'
import { routes } from '../../constants'
import { Creators as ProductStoreCreators } from '../../ducks/product-store/product-store'

const baseUrl = `${config.contentUrl}loja/produto/`

const QTT_PRODUCTS_MIN = 1
const QTT_PRODUCTS_MAX = 8

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
`

const StyledDescription = styled.p`
	white-space: pre-wrap;
`

class StoreProductDetailPage extends React.Component {
	constructor(props) {
		super(props)
		this.getAccordionItems = getAccordionItems.bind(this)
		this.goToPointsExchange = goToPointsExchange.bind(this)
		this.linkify = linkify.bind(this)

		this.state = {
			productId: 0,
			description: '',
			productName: '',
			productImages: [],
			paymentConditions: [{ points: 0, price: 0 }]
		}
	}

	componentDidMount() {
		const {
			user,
			client,
			getPointsInformation,
			match,
			resetProducts
		} = this.props
		const { id } = match.params

		StoreProductService.getDetails(id).then(({ data }) => {
			const { description, name, paymentConditions, productImages } = data
			const images = productImages.map(({ source }) => {
				const imageUrl = `${baseUrl}${source}`
				return { original: imageUrl, thumbnail: imageUrl }
			})

			this.setState({
				description,
				productImages: images,
				productName: name,
				paymentConditions,
				productId: data.id
			})
		})

		var authenticated = user !== null

		if (authenticated && !client.clientPointsWasLoaded) getPointsInformation()

		resetProducts()
	}

	handleProductDecrease = () => {
		const { qttProducts } = this.props

		if (qttProducts > QTT_PRODUCTS_MIN) {
			this.props.setQttProducts(qttProducts - 1)
		}
	}

	handleProductIncrease = () => {
		const { qttProducts } = this.props

		if (qttProducts < QTT_PRODUCTS_MAX) {
			this.props.setQttProducts(qttProducts + 1)
		}
	}

	render() {
		const { client, user } = this.props
		const { productName, paymentConditions, productId } = this.state

		return (
			<StyledStoreProductContainer>
				<div className="main-product-container">
					<Gallery
						className={'gallery-container'}
						items={this.state.productImages}
					/>
					<PaymentInfo
						user={user}
						client={client}
						className={'payment-info-container'}
						productId={productId}
						productName={productName}
						paymentConditions={paymentConditions}
						productQuantity={this.props.qttProducts}
						handleProductDecrease={this.handleProductDecrease}
						handleProductIncrease={this.handleProductIncrease}
						qttMin={QTT_PRODUCTS_MIN}
						qttMax={QTT_PRODUCTS_MAX}
					/>
				</div>
				<div className="description-container">
					<AccordionSecondary
						noAnimated
						noClickable
						arrow={false}
						multiple={false}
						items={this.getAccordionItems()}
					/>
				</div>
			</StyledStoreProductContainer>
		)
	}
}

function goToPointsExchange() {
	const { history } = this.props
	history.push(routes.LOJA)
}

function linkify(text) {
	const urlPattern = /\b((?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/\S*)?)\b/g
	return text.replace(
		urlPattern,
		'<a href=https://$1 target="_blank" rel="noopener noreferrer">$1</a>'
	)
}

function getAccordionItems() {
	return [
		{
			title: 'Descrição',
			content: (
				<div>
					<StyledDescription
						dangerouslySetInnerHTML={{
							__html: this.linkify(this.state.description)
						}}
					/>
					<StyledButtonContainer>
						<Button
							secondary
							type={'button'}
							onClick={this.goToPointsExchange}>
							Veja mais ofertas
						</Button>
					</StyledButtonContainer>
				</div>
			)
		}
	]
}

const mapStateToProps = ({ user, client, productStore }) => ({
	user,
	client,
	qttProducts: productStore.qttProducts
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			getPointsInformation: clientActions.getPointsInformation,
			setQttProducts: ProductStoreCreators.setQttProducts,
			resetProducts: ProductStoreCreators.resetProducts
		},
		dispatch
	)

const connectedStoreProductDetailPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(StoreProductDetailPage)
)

export { connectedStoreProductDetailPage as ModuleRootComponent }
